import React from 'react';
import { FaEnvelope, FaClock, FaDollarSign } from 'react-icons/fa';
import ApplicationStatus from './ApplicationStatus';
import '../../css/common/InternshipOpportunityCard.css';

const InternshipOpportunityCard = ({ opportunity, onClick }) => {
  return (
    <div className="internship-opportunity-card-component" onClick={onClick}>
      <div className="internship-opportunity-card-content">
        <h3 className="internship-opportunity-card-name">{opportunity.name}</h3>
        <div className="internship-opportunity-card-duration">
          <FaClock className="internship-opportunity-card-duration-icon" />
          <span>{opportunity.duration}</span>
        </div>
        <div className="internship-opportunity-card-stipend">
          <FaDollarSign className="internship-opportunity-card-stipend-icon" />
          <span>{opportunity.stipend}</span>
        </div>
        <div className="internship-opportunity-card-contact">
          <FaEnvelope className="internship-opportunity-card-email-icon" title={`Contact ${opportunity.contact.name}`} />
        </div>
        <div className="internship-opportunity-card-status">
          <ApplicationStatus status={opportunity.applicationStatus} />
        </div>
      </div>
    </div>
  );
};

export default InternshipOpportunityCard; 